import React, { Component } from 'react'
import NgrxAuth from '../../auth/Auth'
import { downloadResource } from '../../redux/actions/resourcesActions'
import { localize } from '../../util/Localizer'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import MenuItem from '@material-ui/core/MenuItem'
import mime from 'mime'
import { openBlob, b64toBlob } from '../../util/BlobHelpers'

class PrintBenefitStatement extends Component {
  constructor (props) {
    super(props)
    this.downloadResource = this.downloadResource.bind(this)
    this.downloadFile = this.downloadFile.bind(this)
  }

  downloadResource (resourceType) {
    this.props.downloadResource(resourceType, this.downloadFile)
  }

  downloadFile () {
    const { resource } = this.props
    const hasResource = (typeof resource === 'object' && resource !== null)

    if (hasResource && Array.isArray(resource) && !resource.hasErrorField) {
      resource.forEach(file => {
        // Get a mime type for the given file extension so we
        // can attempt to decode the file correctly:
        const mimeType = mime.getType(file.fileTypeField.toUpperCase())
        // It's very unlikely that we'll come across an unsupported
        // file type, but ignore the file if we do:
        if (mimeType) {
          const blob = b64toBlob(file.fileContentField, mimeType)
          openBlob(blob, file.fileNameField)
        } else {
          this.setState({ showGenericModal: true })
        }
      })
    } else {
      this.setState({ showGenericModal: true })
    }
  }

  render () {
    const memberResources = this.props.memberSummary && this.props.memberSummary.memberResources
    if (memberResources && memberResources.benefitStatement === true) {
      return (
        <MenuItem onClick={() => { this.downloadResource('BenefitStatement') }}>{localize('pages.Resources.benefitStatement')}</MenuItem>
      )
    } else {
      return (
        null
      )
    }
  }
}

function mapStateToProps (state, ownProps) {
  return {
    memberSummary: (state.memberSummaryReducer && state.memberSummaryReducer.memberSummary) || [],
    error: state.ResourcesReducer.error || '',
    resource: state.ResourcesReducer.resource || '',
    isAnyMemberResource: NgrxAuth.isAnyMemberResource
  }
}
const ConnectedPrintBenefitStatement = connect(mapStateToProps, { downloadResource })(injectIntl(PrintBenefitStatement))

export default ConnectedPrintBenefitStatement



// WEBPACK FOOTER //
// ./src/widgets/common/PrintBenefitStatement.js